import React from 'react';
import AuthModal from './AuthModal';

const DoctorSignupPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <AuthModal 
        isOpen={true} 
        onClose={() => {}} 
        defaultTab="signup"
        fixedUserType="doctor"
      />
    </div>
  );
};

export default DoctorSignupPage;
